import React, { useState, useEffect } from "react";
import { Row, Col, Card, CardBody, Spinner } from "reactstrap";
// import rButton from "reactstrap/button";

import {
  deleteRequest,
  putRequest,
  postRequest,
  putRequestForm,
  RBButton,
  deleteConfirmationWords,
} from "components/Common/Utils";
import { useHistory, useParams, useLocation } from "react-router-dom";
import { Link, NavLink } from "react-router-dom";
import moment from "moment";

import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import Lightbox from "react-image-lightbox";

import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Avatar,
} from "@material-ui/core";

import { makeStyles } from "@material-ui/core/styles";
import { ToastContainer, toast } from "react-toastify";

import "./CustomCard.css";

export default function UserOrderDetails() {
  const location = useLocation();
  const state = location.state?.row;

  const [loader, setLoader] = useState(false);
  const [imageLB, setImage] = React.useState("");
  const [OrderInfo, setOrderInfo] = useState([]);
  const [ProductInfo, setProductInfo] = useState([]);

  const [openLightbox, setOpenLightBox] = React.useState(false);

  const useStyles = makeStyles({
    tableHeader: {
      color: "#ffffff", // Use your preferred color
      backgroundColor: "#3f51b5", // Header background color
      fontWeight: "bold",
    },
    descriptionText: {
      fontSize: "0.8rem",
    },
    deleteIcon: {
      color: "red",
    },
    roundImage: {
      borderRadius: "50%",
      width: "75px",
      height: "75px",
    },
    roundImageSm: {
      borderRadius: "50%",
    },

    gridList: {
      width: "100%",
    },
    icon: {
      color: "rgba(255, 55, 25, 0.54)",
    },
  });

  const formatDate = (dateString) => {
    const options = { year: "numeric", month: "long", day: "numeric" };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  const showLightBox = (image) => {
    setImage(image);
    setOpenLightBox(true);
  };

  const {
    productDetails,
    orderDate,
    last_name,
    image,
    country_code,
    gender,
    country,
    nationality,
    email,
    mobile,
    dob,
    createdAt,
    address,
  } = state;

  console.log({ state });

  const OrdersDetails = async () => {
    try {
      setLoader(true);

      // Construct payload
      const payload = {
        orderId: state?._id,
      };

      // Make API request
      const response = await postRequest("order/order-details", payload);

      // Handle response data
      const data = response?.data || [];
      const Productdetails = response?.data?.products[0] || [];

      console.log({ Productdetails });

      setOrderInfo(data);
      setProductInfo(Productdetails);
    } catch (error) {
      console.error("Error fetching Orders list:", error);
      // Optionally display error feedback to the user
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    OrdersDetails();
  }, []);



  
  return (
    <>
      <ToastContainer />
      <Row>
        <Col className="10">
          <div className="page-title-box">
            <h4>User Management</h4>
            <ol className="breadcrumb m-0">
              <li className="breadcrumb-item active">User Management</li>:{" "}
              <li className="breadcrumb-item">Order details</li>
            </ol>
          </div>
        </Col>
        <div className="col-md-2 text-end">
          <button
            type="button"
            class="btn btn-primary btn-lg"
            onClick={() => history.back()}
          >
            <i class="fas fa-chevron-left"></i> Back
          </button>
        </div>

        {loader ? (
          <CardBody style={{ height: "100px" }}>
            <Spinner
              color="info"
              style={{
                height: "4rem",
                width: "4rem",
                position: "absolute",
                left: "50%",
              }}
            >
              Loading...
            </Spinner>
          </CardBody>
        ) : (
          <>
            <Card className="custom-card">
              <div className="carousel-wrapper">
                <Carousel
                  autoPlay
                  infiniteLoop
                  showThumbs={false}
                  showStatus={false}
                  emulateTouch
                  dynamicHeight
                >
                  {ProductInfo?.images?.map((image, index) => (
                    <div
                      key={index}
                      className="cover-image"
                      style={{
                        backgroundImage: `url(${image})`,
                      }}
                      onClick={() => showLightBox(image)}
                    >
                      {/* Optionally add text or content overlay here */}
                    </div>
                  ))}
                </Carousel>
              </div>

              <div className="profile-image">
                <img
                  src={
                    image
                      ? image
                      : `https://ui-avatars.com/api/?background=random&name=${productDetails?.name}`
                  }
                  onClick={() =>
                    showLightBox(
                      image
                        ? image
                        : `https://ui-avatars.com/api/?background=random&name=${productDetails?.name}`
                    )
                  }
                  alt="Image Not Available"
                />
              </div>
              <br></br>

              <div className="row my-2 py-2">
                <div
                  className="userinfo col-md-12 "
                  style={{ paddingLeft: "20px" }}
                >
                  <div className="fst">
                    {" "}
                    <h3> {productDetails?.name} </h3>{" "}
                  </div>
                  <div className="row">
                    <div className="col-md-4 fst py-1">
                      {" "}
                      <p>
                        {" "}
                        Company Name: <span>
                          {ProductInfo?.companyName}
                        </span>{" "}
                      </p>{" "}
                    </div>
                    <div className="col-md-4 fst py-1">
                      {" "}
                      <p>
                        {" "}
                        Product Description:{" "}
                        <span>{ProductInfo?.description}</span>{" "}
                      </p>{" "}
                    </div>
                    <div className="col-md-4 fst py-1">
                      {" "}
                      <p>
                        {" "}
                        Product Quantity: <span>
                          {ProductInfo?.quantity}
                        </span>{" "}
                      </p>{" "}
                    </div>
                    <div className="col-md-4 fst py-1">
                      {" "}
                      <p>
                        {" "}
                        Product Price: <span> {ProductInfo?.price} </span>{" "}
                      </p>{" "}
                    </div>

                    <div className="col-md-4 fst py-1">
                      {" "}
                      <p>
                        {" "}
                        Product Total Price:{" "}
                        <span> {ProductInfo?.totalPrice} </span>{" "}
                      </p>{" "}
                    </div>
                    <div className="col-md-4 fst py-1">
                      {" "}
                      <p>
                        {" "}
                        Order Date{" "}
                        <span> {formatDate(orderDate)} </span>{" "}
                      </p>{" "}
                    </div>
                  </div>
                </div>
              </div>
            </Card>
          </>
        )}

        {openLightbox && (
          <Lightbox
            mainSrc={imageLB}
            onCloseRequest={() => setOpenLightBox(false)}
          />
        )}
      </Row>
      <ToastContainer />{" "}
    </>
  );
}
